// src/pages/CasesPage.js
import React, { useEffect, useState, useCallback } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { getPersons } from '../services/api';

const STATUS = {
  URGENTE:      { bg: '#FF2D2D', label: 'URGENTE' },
  DESAPARECIDA: { bg: '#FF8C00', label: 'DESAPARECIDA' },
  ENCONTRADA:   { bg: '#00C853', label: 'ENCONTRADA' },
};

const Badge = ({ status, gender }) => {
  const m = gender === 'Masculino';
  const labels = {
    URGENTE:      'URGENTE',
    DESAPARECIDA: m ? 'DESAPARECIDO' : 'DESAPARECIDA',
    ENCONTRADA:   m ? 'ENCONTRADO'   : 'ENCONTRADA',
  };
  const colors = STATUS[status] || STATUS.DESAPARECIDA;
  const cfg = { ...colors, label: labels[status] || labels.DESAPARECIDA };
  return (
    <span style={{ display:'inline-block', padding:'2px 9px', borderRadius:6, fontSize:10, fontWeight:800, letterSpacing:.8, background:cfg.bg+'33', color:cfg.bg, border:`1px solid ${cfg.bg}55` }}>
      {cfg.label}
    </span>
  );
};

const FILTERS = [
  { id: '',             label: 'Todas' },
  { id: 'URGENTE',      label: 'Urgentes' },
  { id: 'DESAPARECIDA', label: 'Desaparecidos/as' },
  { id: 'ENCONTRADA',   label: 'Encontrados/as' },
];

export default function CasesPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [persons, setPersons] = useState([]);
  const [total,   setTotal]   = useState(0);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState('');
  const filter = searchParams.get('filter') || '';

  const load = useCallback(() => {
    setLoading(true);
    const params = new URLSearchParams();
    if (filter) params.set('status', filter);
    if (search) params.set('search', search);
    params.set('limit', '50');
    getPersons('?' + params.toString())
      .then(d => { setPersons(d.persons || []); setTotal(d.total || 0); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [filter, search]);

  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); }, [load]);

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '40px 24px' }}>
      <h1 style={{ fontSize: 32, fontWeight: 800, marginBottom: 8 }}>Todos los casos</h1>
      <p style={{ color: '#888', marginBottom: 28, fontSize: 14 }}>{total} casos en la base de datos</p>

      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        <input
          style={{ flex: 1, minWidth: 220, padding: '10px 14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 10, color: '#F0EDE8', fontSize: 14, outline: 'none' }}
          placeholder="Buscar por nombre, ciudad o numero de caso..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {FILTERS.map(f => (
            <button key={f.id}
              onClick={() => setSearchParams(f.id ? { filter: f.id } : {})}
              style={{ padding: '8px 16px', borderRadius: 20, border: 'none', fontSize: 13, fontWeight: 600, cursor: 'pointer', background: filter === f.id ? '#FF2D2D' : 'rgba(255,255,255,0.06)', color: filter === f.id ? '#fff' : '#888' }}
            >{f.label}</button>
          ))}
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#555' }}>Cargando casos...</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: 14 }}>
          {persons.map(p => (
            <Link key={p.id} to={`/caso/${p.id}`} style={{ textDecoration: 'none' }}>
              <div style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 14, border: p.status==='URGENTE'?'1px solid rgba(255,45,45,0.3)':'1px solid rgba(255,255,255,0.08)', display: 'flex', gap: 14, padding: 14, cursor: 'pointer', transition: 'background .2s' }}
                onMouseEnter={e => e.currentTarget.style.background='rgba(255,255,255,0.07)'}
                onMouseLeave={e => e.currentTarget.style.background='rgba(255,255,255,0.04)'}
              >
                <div style={{ width: 64, height: 64, borderRadius: 12, overflow: 'hidden', flexShrink: 0, background: '#1A0A2E' }}>
                  {p.photoUrl
                    ? <img src={p.photoUrl} alt={p.name} style={{ width:'100%', height:'100%', objectFit:'cover' }} onError={e => { e.target.style.display='none'; }} />
                    : <div style={{ width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, color:'#7B93D4', fontSize:20 }}>{p.name.split(' ').slice(0,2).map(n=>n[0]).join('')}</div>
                  }
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Badge status={p.status} gender={p.gender} />
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#F0EDE8', margin: '3px 0 2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</div>
                  <div style={{ fontSize: 12, color: '#888' }}>{p.age} a&ntilde;os &middot; {p.location}</div>
                  <div style={{ fontSize: 11, color: '#555', marginTop: 2 }}>&#128336; {p.lastSeen}</div>
                </div>
                <span style={{ color: '#444', fontSize: 18, alignSelf: 'center' }}>&#8250;</span>
              </div>
            </Link>
          ))}
          {persons.length === 0 && (
            <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: 60, color: '#555' }}>No se encontraron casos.</div>
          )}
        </div>
      )}
    </div>
  );
}
